<template>
  <div class="chat-input">
    <div class="chat-input-container">
      <el-x-sender
          ref="senderRef"
          :autoSize="{ minRows: 2, maxRows: 8 }"
          :loading="loading"
          :value="value"
          variant="updown"
          @input="$emit('input', $event)"
          @submit="$emit('send', $event)"
      >
        <template #header>
          <SenderHeader
              :file-list="uploadedFiles"
              @delete-file="$emit('delete-file', $event)"
          />
        </template>

        <template #prefix>
          <el-popover
              placement="top"
              popper-class="models-popper"
              trigger="click"
          >
            <div class="models-panel">
              <div class="models-panel-header">
                <span class="models-panel-title">选择对比模型</span>
                <div class="models-panel-actions">
                  <span class="models-panel-btn models-panel-btn--all" @click="selectAllModels">全选</span>
                  <span class="models-panel-sep">|</span>
                  <span class="models-panel-btn models-panel-btn--clear" @click="clearAllModels">取消</span>
                </div>
              </div>
              <div class="models-panel-divider"></div>
              <div class="models-panel-list">
                <el-checkbox-group v-model="checkList" @change="modelSelect">
                  <el-checkbox v-for="el in models" :key="el.model_id" :label="el.model_id">{{ el.model_name }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
            <div slot="reference" class="models">
              <i class="el-icon-s-operation models-icon"></i>
              <span class="models-count">{{ checkList.length }}个</span>
              <i class="el-icon-arrow-right models-arrow"></i>
            </div>

          </el-popover>
          <!--          <div style="display: flex; align-items: center; flex-wrap: wrap">-->
          <!--            文件上传-->
          <!--            <el-button-->
          <!--                color="#626aef"-->
          <!--                plain-->
          <!--                round-->
          <!--                size="small"-->
          <!--                @click="$emit('file-upload')"-->
          <!--            >-->
          <!--              <i class="el-icon-paperclip"></i>-->
          <!--            </el-button>-->

          <!-- <template>
            <div
              :class="['thinking', { 'thinking--active': isSelect }]"
              @click="$emit('update:is-select', !isSelect)"
            >
              <i class="el-icon-plus"></i>
              <span>深度思考</span>
            </div>
          </template> -->
          <!--          </div>-->
        </template>
        <template #action-list>
          <div style="display: flex; align-items: center; gap: 16px">
            <img alt="" src="@/assets/images/home6.png" style="width: 32px; height: 32px;display: flex;cursor: pointer"
                 @click="$emit('file-upload')"/>
            <el-button v-if="value||value.trim()" v-loading="loading" class="send-new-btn"
                       @click="$emit('send', value)">
              <img alt="" src="@/assets/images/home7.png">
              <span>发送</span>
            </el-button>
            <el-button
                v-else
                class="send-new-btn"
                style="opacity: 0.5"
            ><img alt="" src="@/assets/images/home7.png" style="margin: 0">
            </el-button>
            <!-- 录音按钮 -->

            <!--                    <el-button-->
            <!--                        :class="[-->
            <!--                        'record-btn',-->
            <!--                        { 'record-btn&#45;&#45;active': recordLoading, 'record-btn&#45;&#45;error': recordError },-->
            <!--                      ]"-->
            <!--                        :disabled="loading"-->
            <!--                        :style="-->
            <!--                        recordLoading-->
            <!--                          ? 'background: #ff6b6b; color: #fff'-->
            <!--                          : 'background: #52c41a; color: #fff'-->
            <!--                      "-->
            <!--                        circle-->
            <!--                        size="small"-->
            <!--                        @click="handleRecord"-->
            <!--                    >-->
            <!--                      <i :class="recordLoading ? 'el-icon-close' : 'el-icon-microphone'"></i>-->
            <!--                    </el-button>-->

            <!--                    <el-button-->
            <!--                        v-if="loading"-->
            <!--                        circle-->
            <!--                        class="stop-btn"-->
            <!--                        size="small"-->
            <!--                        style="background: #f56c6c; color: #fff"-->
            <!--                        @click="$emit('stop')"-->
            <!--                    >-->
            <!--                      <i class="el-icon-close"></i>-->
            <!--                    </el-button>-->
          </div>
        </template>
      </el-x-sender>
    </div>

    <div class="chat-input-footer">内容由 AI 生成，请仔细甄别</div>
  </div>
</template>

<script>
import {recordMixin} from 'vue-element-ui-x';
import SenderHeader from './SenderHeader.vue';

export default {
  name: 'ChatInput',
  components: {SenderHeader},
  mixins: [recordMixin],
  props: {
    chat_id: {
      type: Number,
      default: 0
    },
    models: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isSelect: {
      type: Boolean,
      default: false,
    },
    uploadedFiles: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      recordError: null,
      recordAnimating: false,
      checkList: []//已选择模型
    };
  },
  methods: {
    modelSelect() {
      let arr = JSON.parse(JSON.stringify(this.models));
      let checked_list = arr.filter(item => this.checkList.includes(item.model_id)).map(el => {
        return {
          ...el,
          checked: true
        }
      });
      this.$emit('modelSelectEvent', checked_list);
    },
    // 全选所有模型
    selectAllModels() {
      this.checkList = this.models.map(el => el.model_id);
      this.modelSelect();
    },
    // 取消全部选择
    clearAllModels() {
      this.checkList = [];
      this.modelSelect();
    },
    handleRecord() {
      if (this.recordLoading) {
        this.stopRecord();
      } else {
        this.recordError = null;
        this.startRecord();
      }
    },

    handleRecordResult(value) {
      if (value && value.trim()) {
        // 如果输入框已有内容，追加到末尾，否则直接设置
        const currentValue = this.value || '';
        const newValue = currentValue ? `${currentValue} ${value}` : value;
        this.$emit('input', newValue);
      }
    },

    handleRecordError(error) {
      this.recordError = error;
      this.recordAnimating = true;
      setTimeout(() => {
        this.recordAnimating = false;
      }, 500);

      // 显示用户友好的错误信息
      let errorMessage = '录音失败';
      if (error.message) {
        if (error.message.includes('not-allowed')) {
          errorMessage = '请允许麦克风权限后重试';
        } else if (error.message.includes('network')) {
          errorMessage = '网络错误，请检查网络连接';
        } else if (error.message.includes('no-speech')) {
          errorMessage = '未检测到语音，请重试';
        } else {
          errorMessage = error.message;
        }
      }

      this.$message && this.$message.error(errorMessage);
    },
  },
  watch: {
    uploadedFiles: {
      handler(newFiles) {
        // 监听上传文件变化，控制header显示隐藏
        this.$nextTick(() => {
          const senderRef = this.$refs.senderRef;
          if (senderRef) {
            if (newFiles.length > 0) {
              senderRef.openHeader();
            } else {
              senderRef.closeHeader();
            }
          }
        });
      },
      deep: true,
      immediate: true,
    },
    models: {
      handler(newFiles) {
        // 监听上传文件变化，控制header显示隐藏
        this.$nextTick(() => {
          if (newFiles.length > 0) {
            this.checkList = newFiles.filter(item => item.checked).map(el => el.model_id)
          }
        });
      },
      deep: true,
      immediate: true,
    }
  },
  mounted() {
    // 初始化录音功能
    this.initRecord({
      onStart: () => {
        this.recordAnimating = true;
        console.log('开始录音');
      },
      onEnd: value => {
        this.recordAnimating = false;
        this.handleRecordResult(value);
        console.log('录音结束', value);
      },
      onError: error => {
        this.handleRecordError(error);
        console.error('录音错误', error);
      },
      onResult: result => {
        // 实时识别结果处理（可选）
        console.log('实时识别结果：', result);
      },
    });
  },
  beforeDestroy() {
    // 组件销毁时清理录音资源
    if (this.cleanupRecord) {
      this.cleanupRecord();
    }
  },
};
</script>

<style lang="scss" scoped>
.models {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 5px 12px;
  border: 1px solid #E5E7EF;
  border-radius: 26px;
  box-sizing: border-box;
  background: #FFFFFF;
  color: #1A1A1A;
  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;
  cursor: pointer;
  transition: border-color 0.2s ease, background-color 0.2s ease;

  .models-icon {
    font-size: 16px;
    font-weight: bold;
    color: #4D79FF;
  }

  .models-count {
    font-weight: 500;
  }

  .models-arrow {
    margin-left: 2px;
    font-size: 12px;
    color: #858B9F;
    transition: color 0.2s ease, transform 0.2s ease;
  }

  &:hover {
    border-color: #8CC5FF;
    background: #F0F6FF;

    .models-arrow {
      color: #4D79FF;
    }
  }
}

::v-deep .el-x-sender .el-x-sender-content .el-x-sender-input[data-v-5824e87e] .el-textarea__inner {
  font-size: 16px;
}

::v-deep .el-button {
  border: none;
}

::v-deep .el-button > span {
  display: flex;
  align-items: center;
  justify-content: center;
}

.send-new-btn {
  width: 80px;
  height: 32px;
  background: #006EF4;
  border-radius: 272px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  cursor: pointer;

  span {
    display: flex;
  }

  img {
    width: 20px;
    height: 20px;
    display: flex;
    margin-right: 4px;
  }
}

.el-button + .el-button,
.el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 0 !important;
}

.chat-input {
  flex-shrink: 0;
  flex-direction: column;
  align-items: center;
  margin-top: auto;
  display: flex;
  position: -webkit-sticky;
  position: sticky;
  bottom: 0;

  .chat-input-container {
    //max-width: 960px;
    flex-grow: 1;
    width: 100%;
    position: relative;
  }

  .chat-input-footer {
    font-size: 12px;
    color: #a3a3a3;
    margin: 6px 0;
    line-height: 14px;
  }
}

.thinking {
  display: flex;
  height: 32px;
  box-sizing: border-box;
  align-items: center;
  gap: 4px;
  padding: 2px 12px;
  border-width: 1px;
  border-style: solid;
  border-color: #0000001f;
  border-radius: 15px;
  cursor: pointer;
  font-size: 12px;
  color: black;
  transition: background-color 0.3s ease;

  // 未激活时的hover效果
  &:hover {
    background-color: #e0e4ed;
  }

  // 激活状态
  &--active {
    background-color: #dbeafe;
    color: #4d6bfe;
    border-color: #007aff26;
    padding: 3px 12px;
    font-weight: 700;

    // 激活时的hover效果
    &:hover {
      background-color: #c3daf8;
    }
  }
}

// 录音按钮样式
.record-btn {
  position: relative;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }

  // 录音激活状态 - 呼吸灯效果
  &--active {
    animation: recordPulse 1.5s ease-in-out infinite;

    &::after {
      content: '';
      position: absolute;
      top: -2px;
      left: -2px;
      right: -2px;
      bottom: -2px;
      border-radius: 50%;
      background: rgba(255, 107, 107, 0.3);
      animation: recordRipple 1.5s ease-out infinite;
    }
  }

  // 错误状态
  &--error {
    animation: recordShake 0.5s ease-in-out;
  }
}

// 录音按钮呼吸灯动画
@keyframes recordPulse {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(255, 107, 107, 0.7);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(255, 107, 107, 0.1);
  }
}

// 录音按钮波纹动画
@keyframes recordRipple {
  0% {
    transform: scale(1);
    opacity: 0.6;
  }
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}

// 错误震动动画
@keyframes recordShake {
  0%,
  100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-3px);
  }
  75% {
    transform: translateX(3px);
  }
}

@media (max-width: 767px) {
  .chat-input {
    padding: 0 16px 16px;

    .chat-input-container {
      max-width: none;
    }
  }
}
</style>

<style lang="scss">
// 模型选择弹层（el-popover 内容会被传送到 body，样式必须全局生效）
.models-popper.el-popover {
  min-width: 200px;
  padding: 0;
  border-radius: 12px;

  .models-panel {
    .models-panel-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px;

      .models-panel-title {
        font-size: 14px;
        font-weight: 600;
        color: #1A1A1A;
      }

      .models-panel-actions {
        display: flex;
        align-items: center;
        gap: 0;

        .models-panel-sep {
          font-size: 12px;
          color: #E3E6EC;
          margin: 0 2px;
        }

        .models-panel-btn {
          font-size: 13px;
          cursor: pointer;
          user-select: none;
          font-weight: 500;
          padding: 4px 4px;
          border-radius: 6px;
          transition: opacity 0.2s ease, background-color 0.2s ease;

          &:hover {
            opacity: 0.75;
          }
        }

        .models-panel-btn--all {
          color: #4D79FF;

          &:hover {
            background: #EFF5FF;
          }
        }

        .models-panel-btn--clear {
          color: #858B9F;

          &:hover {
            background: #F5F5F8;
          }
        }
      }
    }

    .models-panel-divider {
      height: 1px;
      background: #EEF1F6;
    }

    .models-panel-list {
      max-height: 260px;
      overflow-y: auto;
      padding: 6px 0 8px;

      .el-checkbox {
        display: block;
        margin-right: 0;
        padding: 0 16px;
        line-height: 40px;
        white-space: nowrap;
        transition: background-color 0.15s ease;

        &:hover {
          background: #F7F9FE;
        }

        .el-checkbox__label {
          font-size: 14px;
          color: #333333;
        }

        .el-checkbox__input.is-checked .el-checkbox__inner {
          background-color: #4D79FF;
          border-color: #4D79FF;
        }

        .el-checkbox__input.is-checked + .el-checkbox__label {
          color: #4D79FF;
        }
      }

      // 列表滚动条
      &::-webkit-scrollbar {
        width: 6px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.15);
        border-radius: 10px;
      }

      &::-webkit-scrollbar-track {
        background: transparent;
      }
    }
  }
}
</style>
